import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import {
  addDoc,
  collection,
  doc,
  getDoc,
  onSnapshot,
  query,
  where,
  Timestamp,
} from 'firebase/firestore';
import { auth, db } from '../firebase';
import { Button, TextField, Autocomplete } from '@mui/material';
import moment from 'moment';

export default function Purchaseorder() {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    },
  });

  // 🔹 States
  const [userData, setUserData] = useState(null);
  const [username, setUsername] = useState('');
  const [departments, setDepartments] = useState([]);
  const [products, setProducts] = useState([]);
  const [poitems, setPoitems] = useState([]);

  const [podate, setPodate] = useState(moment().format(''));
  const [billdate, setBilldate] = useState(moment().format(''));
  const [fromname, setFromname] = useState('e');
  const [fromaddress, setFromaddress] = useState('');
  const [toname, setToname] = useState('');
  const [designation, setDesignation] = useState('');
  const [budgetamount, setBudgetamount] = useState('');
  const [approveamount, setApproveamount] = useState('');
  const [subject, setSubject] = useState('');
  const [pototal, setPototal] = useState(0);

  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [descreption, setDescreption] = useState('');
  const [size, setSize] = useState('');
  const [quantity, setQuantity] = useState(0);
  const [rate, setRate] = useState(0);
  const [taxable, setTaxable] = useState(0);
  const [gst, setGst] = useState(0);
  const [gstAmount, setGstAmount] = useState(0);
  const [total, setTotal] = useState(0);

  const [propertyId, setPropertyId] = useState(null);

  useEffect(() => {
    const unsub = auth.onAuthStateChanged(async (user) => {
      setUserData(user);

      if (user) {

        // 🔹 Fetch propertyId from authroles
        const q = query(
          collection(db, "authroles"),
          where("uid", "==", user.uid)
        );

        const unsubscribeRole = onSnapshot(q, (snapshot) => {
          if (!snapshot.empty) {
            const roleData = snapshot.docs[0].data();
            setPropertyId(roleData.propertyId);
          }
        });

        return () => unsubscribeRole();
      }
    });

    return () => unsub();
  }, []);

  useEffect(() => {
    if (!propertyId) return;

    const q = query(
      collection(db, "departments"),
      where("propertyId", "==", propertyId)
    );

    const unsub = onSnapshot(q, (snapshot) =>
      setDepartments(snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      })))
    );

    return () => unsub();
  }, [propertyId]);
  // 🔹 Fetch Products per Department
  useEffect(() => {
    if (!selectedDepartment || !propertyId) {
      setProducts([]);
      return;
    }

    const q = query(
      collection(db, "storeproducts"),
      where("departmentid", "==", selectedDepartment.id),
      where("propertyId", "==", propertyId)
    );

    const unsub = onSnapshot(q, (snapshot) =>
      setProducts(snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      })))
    );

    return () => unsub();
  }, [selectedDepartment, propertyId]);

  // 🔹 Calculate Taxable, GST, Total
  const calculateValues = (qty, r, g) => {
    const qtyNum = parseFloat(qty) || 0;
    const rateNum = parseFloat(r) || 0;
    const gstNum = parseFloat(g) || 0;
    const newTaxable = qtyNum * rateNum;
    const newGstAmount = (newTaxable * gstNum) / 100;
    const newTotal = newTaxable + newGstAmount;
    setTaxable(newTaxable.toFixed(2));
    setGstAmount(newGstAmount.toFixed(2));
    setTotal(newTotal.toFixed(2));
  };

  // 🔹 Add Item to PO
  const handleAddItem = () => {
    if (!selectedProduct || quantity <= 0 || rate <= 0) {
      Toast.fire({ icon: 'error', title: 'fill all required fields' });
      return;
    }

    const newItem = {
      department: selectedDepartment?.department || '',
      productid: selectedProduct.id,
      product: selectedProduct.product,
      descreption,
      size,
      quantity,
      rate,
      taxable,
      gst,
      gstAmount,
      total,
      username,
    };

    setPoitems([...poitems, newItem]);

    // ✅ Reset product fields but keep department selected
    setSelectedProduct(null);
    setQuantity(0);
    setRate(0);
    setSize('');
    setDescreption('');
    setGst(0);
    setTaxable(0);
    setGstAmount(0);
    setTotal(0);

    // Update PO Total
    const newPototal = poitems.reduce((sum, item) => sum + parseFloat(item.total), 0) + parseFloat(newItem.total);
    setPototal(newPototal.toFixed(2));
  };

  // 🔹 Remove Item
  const removeItem = (itemToRemove) => {
    if (!window.confirm('Are you sure you want to remove this item?')) return;
    const updatedItems = poitems.filter((item) => item !== itemToRemove);
    setPoitems(updatedItems);
    const newPototal = updatedItems.reduce((sum, item) => sum + parseFloat(item.total), 0);
    setPototal(newPototal.toFixed(2));
  };

  // 🔹 Submit PO
  const submitData = async () => {
    try {
      const poRef = await addDoc(collection(db, 'poregisters'), {
        poitems,
        podate,
        toname,
        fromname,
        fromaddress,
        designation,
        billdate,
        budgetamount,
        approveamount,
        subject,
        pototal,
        type: 'Purchase Order',
        status: 'Pending',
        uid: userData.uid,
        createdAt: Timestamp.now(),
          propertyId,   // ✅ added

      });

      for (let item of poitems) {
        await addDoc(collection(db, 'poitems'), {
          poid: poRef.id,
          ...item,
          quantity: parseFloat(item.quantity),
          createdAt: Timestamp.now(),
          podate,
            propertyId,   // ✅ added

        });
      }

      Toast.fire({ icon: 'success', title: 'Purchase Order submitted successfully' });
      setPoitems([]);
      setSelectedProduct(null);
      setSelectedDepartment(null);
      setQuantity(0);
      setRate(0);
      setSize('');
      setDescreption('');
      setGst(0);
      setTaxable(0);
      setGstAmount(0);
      setTotal(0);
      setPototal(0);
    } catch (err) {
      Toast.fire({ icon: 'error', title: 'Error: ' + err.message });
    }
  };

  return (
    <div className="content-wrapper" style={{ backgroundColor: '#fff', marginTop: 20 }}>
      <section className="content">
        <div className="container-fluid">
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
            <h4>Purchase Order</h4>
            <Button variant="contained" color="info" href="view-purchase-order">View Purchase Orders</Button>
          </div>

          {/* Sender & Receiver */}
          <div className="row mb-3">
            <div className="col-sm-4">
              <TextField label="From Name" value={fromname} onChange={(e) => setFromname(e.target.value)} fullWidth size="small" /><br /><br />
              <TextField label="From Address" value={fromaddress} onChange={(e) => setFromaddress(e.target.value)} fullWidth size="small" /><br /><br />
              <TextField label="PO Date" type="date" value={podate} onChange={(e) => setPodate(e.target.value)} fullWidth size="small" />
            </div>
            <div className="col-sm-4">
              <TextField label="To Name" value={toname} onChange={(e) => setToname(e.target.value)} fullWidth size="small" /><br /><br />
              <TextField label="Designation" value={designation} onChange={(e) => setDesignation(e.target.value)} fullWidth size="small" /><br /><br />
              <TextField label="Bill Date" type="date" value={billdate} onChange={(e) => setBilldate(e.target.value)} fullWidth size="small" />
            </div>
            <div className="col-sm-4">
              <TextField label="Budget Amount" value={budgetamount} onChange={(e) => setBudgetamount(e.target.value)} fullWidth size="small" /><br /><br />
              <TextField label="Approval Amount" value={approveamount} onChange={(e) => setApproveamount(e.target.value)} fullWidth size="small" /><br /><br />
              <TextField label="Subject" value={subject} onChange={(e) => setSubject(e.target.value)} fullWidth />
            </div>
          </div>

          {/* Add Product Row */}
          <div className="card mb-3">
            <div className="card-body">
              <div className="row align-items-center">
                <div className="col-sm-2">
                  <Autocomplete
                    options={departments}
                    getOptionLabel={(option) => option.department || ''}
                    value={selectedDepartment}
                    onChange={(e, newValue) => setSelectedDepartment(newValue)}
                    renderInput={(params) => <TextField {...params} label="Department" size="small" fullWidth />}
                  />
                </div>
                <div className="col-sm-2">
                  <Autocomplete
                    options={products}
                    getOptionLabel={(option) => option.product || ''}
                    value={selectedProduct}
                    onChange={(e, newValue) => setSelectedProduct(newValue)}
                    renderInput={(params) => <TextField {...params} label="Product" size="small" fullWidth />}
                    disabled={!selectedDepartment}
                  />
                </div>
                <div className="col-sm-2"><TextField label="Description" value={descreption} onChange={(e) => setDescreption(e.target.value)} size="small" fullWidth /></div>
                <div className="col-sm-1"><TextField label="Qty" type="number" value={quantity} onChange={(e) => { setQuantity(e.target.value); calculateValues(e.target.value, rate, gst); }} size="small" fullWidth /></div>
                <div className="col-sm-1"><TextField label="Rate" type="number" value={rate} onChange={(e) => { setRate(e.target.value); calculateValues(quantity, e.target.value, gst); }} size="small" fullWidth /></div>
                <div className="col-sm-1"><TextField label="Size" value={size} onChange={(e) => setSize(e.target.value)} size="small" fullWidth /></div>
                <div className="col-sm-1"><TextField label="GST %" type="number" value={gst} onChange={(e) => { setGst(e.target.value); calculateValues(quantity, rate, e.target.value); }} size="small" fullWidth /></div>
                <div className="col-sm-2">
                  <Button variant="contained" color="success" onClick={handleAddItem}>Add Item</Button>
                </div>
              </div>
            </div>
          </div>

          {/* Items Table */}
          <div className="card mb-3">
            <div className="card-body">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Department</th>
                    <th>Product</th>
                    <th>Description</th>
                    <th>Size</th>
                    <th>Qty</th>
                    <th>Rate</th>
                    <th>Taxable</th>
                    <th>GST</th>
                    <th>GST Amt</th>
                    <th>Total</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {poitems.map((item, index) => (
                    <tr key={index}>
                      <td>{item.department}</td>
                      <td>{item.product}</td>
                      <td>{item.descreption}</td>
                      <td>{item.size}</td>
                      <td>{item.quantity}</td>
                      <td>{item.rate}</td>
                      <td>{item.taxable}</td>
                      <td>{item.gst}</td>
                      <td>{item.gstAmount}</td>
                      <td>{item.total}</td>
                      <td><Button color="error" size="small" onClick={() => removeItem(item)}>Remove</Button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* PO Total & Submit */}
          <div className="row mb-3">
            <div className="col-sm-4">
              <TextField label="PO Total" value={pototal} InputProps={{ readOnly: true }} size="small" fullWidth />
            </div>
            <div className="col-sm-8 text-right">
              <Button variant="contained" color="primary" onClick={submitData}>Submit Purchase Order</Button>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}
